// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChildNodeName__text___mD8py {
    position: relative;
    white-space: pre-line;
}

.ChildNodeName__bold___M46Q3 {
    font-weight: bold;
}

.ChildNodeName__randomNode___I87Qf {
    color: black;
    font-weight: bold;
    font-size: 22px;
    padding: 3px 5px;
    border-radius: 2px;
    background-image: linear-gradient(
        135deg,
        #ffc700 25%,
        #ffb81f 25%,
        #ffb81f 50%,
        #ffc700 50%,
        #ffc700 75%,
        #ffb81f 75%,
        #ffb81f 100%
    );
    background-size: 28.28px 28.28px;
}

.ChildNodeName__randomNode___I87Qf:focus {
    color: black;
}

.ChildNodeName__highlight___pmptJ:hover {
    color: black;
}

.ChildNodeName__noChildren___B7nqG {
    opacity: 0.8;
}

.ChildNodeName__missingQuizWordWarning___i53NV {
    color: coral;
    padding-left: 10px;
}

.ChildNodeName__node___K46S6:hover {
    text-shadow: 0px 0px 10px gold;
}

.ChildNodeName__isDragging___wPkVY {
    opacity: 0.5;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `ChildNodeName__text___mD8py`,
	"bold": `ChildNodeName__bold___M46Q3`,
	"randomNode": `ChildNodeName__randomNode___I87Qf`,
	"highlight": `ChildNodeName__highlight___pmptJ`,
	"noChildren": `ChildNodeName__noChildren___B7nqG`,
	"missingQuizWordWarning": `ChildNodeName__missingQuizWordWarning___i53NV`,
	"node": `ChildNodeName__node___K46S6`,
	"isDragging": `ChildNodeName__isDragging___wPkVY`
};
module.exports = ___CSS_LOADER_EXPORT___;
